import React from 'react';
import { __t } from '../../utils/t';
import { HoverTooltip } from '../HoverTooltip';
import { Icon } from '../Icon';

import './styles.scss';
import { useIsMobile } from '../../hooks';

interface Props {
    isFavorite: boolean;
    onClick: () => void;
}

export const FavoritesButton = ({ isFavorite, onClick }: Props) => {
    const isMobile = useIsMobile();

    const clickHandler = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        onClick();
    };

    return (
        <div className={`favorites-button ${isFavorite ? 'favorites-button--checked' : ''}`}>
            {isMobile ? (
                <button
                    className='favorites-button__icon hover-tooltip__icon'
                    data-url='/cv/favorite-toggle'
                    onClick={clickHandler}
                >
                    {isFavorite ? <Icon icon='star-solid' size='20px' /> : <Icon icon='star-light' size='20px' />}
                </button>
            ) : (
                <HoverTooltip
                    className='vacancy-date__tooltip'
                    text={isFavorite ? __t('Добавлено в избранное') : __t('Добавить в избранное')}
                    theme='dark'
                    showArrow={true}
                >
                    <button
                        className='favorites-button__icon hover-tooltip__icon'
                        data-url='/cv/favorite-toggle'
                        onClick={clickHandler}
                    >
                        {isFavorite ? <Icon icon='star-solid' size='20px' /> : <Icon icon='star-light' size='20px' />}
                    </button>
                </HoverTooltip>
            )}
        </div>
    );
};
